import React, { useEffect, useState } from "react";
import {
  TextField,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { getMyOfficeUsers } from "../../../api/userService";

const UserAutocomplete = ({
  userId = "",
  value,
  onChange,
  label = "Select User",
  ...props
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getMyOfficeUsers();
        setItems(response || []);
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  return (
    <Autocomplete
      {...props}
      options={items}
      getOptionLabel={(option) => option.professional_name ? option.professional_name : option.name || ""}
      value={
        items.find((item) => item.id === value) || null
      }
      onChange={(event, newValue) =>
        onChange?.(newValue ? newValue.id : "")
      }
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default UserAutocomplete;